// Dados dos cardápios do Cuore Brasiliano

export const menuData = {
  pratos: {
    title: "Pratos Feitos",
    subtitle: "Pratos tradicionais brasileiros para o almoço",
    items: [
      {
        id: "mineirinho",
        name: "Mineirinho",
        description: "Arroz, Feijão, Bife di Manzo, Batata frita ou mandioca",
        price: "€14.00",
        category: "pratos"
      },
      {
        id: "bahiana",
        name: "Bahiana",
        description: "Arroz / Feijão / Manzo / Ovo / Batata frita",
        price: "€14.00",
        category: "pratos",
        note: "Acompanhamento: Farofa / Vinagrete / Salada"
      },
      {
        id: "paulista",
        name: "Paulista",
        description: "Arroz / Feijão / Pollo Impanato / Batata frita",
        price: "€14.00",
        category: "pratos",
        note: "Acompanhamento: Salada / Vinagrete / Salsa Rose"
      },
      {
        id: "gaucho",
        name: "Gaúcho",
        description: "Arroz, Feijão, Picanha, Vinagrete, Farofa",
        price: "€18.00",
        category: "pratos"
      },
      {
        id: "carioquinha",
        name: "Carioquinha",
        description: "Arroz / Feijão / Filé de Frango / Ovo / Mandioca",
        price: "€14.00",
        category: "pratos",
        note: "Acompanhamento: Vinagrete / Farofa / Salada"
      },
      {
        id: "nordestino",
        name: "Nordestino",
        description: "Arroz / Feijão / Alette di Pollo / Mandioca",
        price: "€14.00",
        category: "pratos",
        note: "Acompanhamento: Vinagrete / Farofa / Salada"
      },
      {
        id: "goiano",
        name: "Goiano",
        description: "Arroz, Feijão, Linguiça, Batata frita, Vinagrete",
        price: "€14.00",
        category: "pratos"
      }
    ],
    note: "Todos os pratos têm de acompanhamento a Salada"
  },
  
  
  petiscos: {
    title: "Petiscos",
    subtitle: "Porções brasileiras para compartilhar",
    items: [
      {
        id: "churrasquinho",
        name: "Churrasquinho",
        description: "Churrasquinho",
        price: "€3.50",
        category: "petiscos",
        unit: "cada"
      },
      {
        id: "torresmo",
        name: "Porção Torresmo",
        description: "Torresmo crocante",
        price: "€7.00",
        category: "petiscos"
      },
      {
        id: "mix-pasteis",
        name: "Mix de Pastéis",
        description: "9 unidades - Carne e Queijo",
        price: "€10.00",
        category: "petiscos"
      },
      {
        id: "coxinhas",
        name: "Coxinhas",
        description: "10 unidades",
        price: "€10.00",
        category: "petiscos"
      },
      {
        id: "bolinha-queijo",
        name: "Bolinha de Queijo",
        description: "10 unidades",
        price: "€10.00",
        category: "petiscos"
      },
      {
        id: "bolinho-ceci",
        name: "Bolinho di Ceci",
        description: "Bolinho de grão de bico",
        price: "€12.00",
        category: "petiscos",
        unit: "10 unidades"
      },
      {
        id: "mandioca-frita",
        name: "Mandioca Frita",
        description: "Mandioca frita",
        price: "€10.00",
        category: "petiscos"
      },
      {
        id: "batata-frita",
        name: "Porção Batata Frita",
        description: "Batata frita crocante",
        price: "€5.00",
        category: "petiscos"
      },
      {
        id: "pao-queijo",
        name: "Pão de Queijo",
        description: "10 unidades",
        price: "€8.00",
        category: "petiscos"
      },
      {
        id: "porcao-mista",
        name: "Porção Mista",
        description: "Picanha ou Coração ou Asinhas - Batata frita ou Mandioca",
        price: "€25.00",
        category: "petiscos"
      },
      {
        id: "porcao-picanha",
        name: "Porção de Picanha",
        description: "Porção de picanha grelhada",
        price: "€16.00",
        category: "petiscos",
        note: "Acompanhamento: Vinagrete / Farofa / Salada"
      },
      {
        id: "porcao-coracao-galinha",
        name: "Porção Coração de Galinha",
        description: "Porção de coração de galinha",
        price: "€14.00",
        category: "petiscos",
        note: "Acompanhamento: Vinagrete / Farofa / Salada"
      },
      {
        id: "porcao-asinhas-frango",
        name: "Porção de Asinhas de Frango",
        description: "Porção de asinhas de frango fritas",
        price: "€13.00",
        category: "petiscos",
        note: "Acompanhamento: Salada / Vinagrete / Farofa"
      },
      {
        id: "quibe-queijo",
        name: "Quibe Recheado com Queijo",
        description: "Quibe recheado com queijo",
        price: "€6.00",
        category: "petiscos",
        unit: "3 unidades"
      },
      {
        id: "porcao-frango-empanado",
        name: "Porção de Frango Empanado",
        description: "Porção de frango empanado",
        price: "€15.00",
        category: "petiscos",
        note: "Acompanhamento: Salsa Rose / Vinagrete / Salada"
      }
    ]
  },

  bebidas: {
    title: "Bebidas",
    subtitle: "Refrigerantes e bebidas não alcoólicas",
    items: [
      {
        id: "acqua",
        name: "Acqua",
        description: "Água natural",
        price: "€1.20",
        category: "bebidas"
      },
      {
        id: "coca-cola",
        name: "Coca-Cola",
        description: "Coca-Cola 33cl",
        price: "€3.00",
        category: "bebidas"
      },
      {
        id: "guarana",
        name: "Guaraná",
        description: "Guaraná Antarctica 33cl",
        price: "€3.50",
        category: "bebidas"
      },
      {
        id: "fanta",
        name: "Fanta",
        description: "Fanta 33cl",
        price: "€3.00",
        category: "bebidas"
      },
      {
        id: "te-limone",
        name: "Té Limone ou Pesca",
        description: "Chá de limão ou pêssego",
        price: "€3.50",
        category: "bebidas"
      },
      {
        id: "sprite",
        name: "Sprite",
        description: "Sprite 33cl",
        price: "€3.00",
        category: "bebidas"
      },
      {
        id: "spremuta",
        name: "Spremuta",
        description: "Suco natural",
        price: "€4.00",
        category: "bebidas"
      },
      {
        id: "redbull",
        name: "Red Bull",
        description: "Red Bull 25cl",
        price: "€3.50",
        category: "bebidas"
      }
    ]
  },

  drinks: {
    title: "Drinks",
    subtitle: "Coquetéis e bebidas alcoólicas",
    items: [
      {
        id: "spritz-aperol",
        name: "Spritz Aperol",
        description: "Spritz com Aperol",
        price: "€5.00",
        category: "drinks"
      },
      {
        id: "spritz-campari",
        name: "Spritz Campari",
        description: "Spritz com Campari",
        price: "€5.00",
        category: "drinks"
      },
      {
        id: "spritz-limoncello",
        name: "Spritz Limoncello",
        description: "Spritz com Limoncello",
        price: "€5.00",
        category: "drinks"
      },
      {
        id: "caipirinha",
        name: "Caipirinha",
        description: "Caipirinha com vodka ou cachaça",
        price: "€5.00",
        category: "drinks"
      },
      {
        id: "caipirinha-maracuja",
        name: "Caipirinha de Maracujá",
        description: "Caipirinha de maracujá",
        price: "€6.00",
        category: "drinks"
      },
      {
        id: "caipiroska",
        name: "Caipiroska",
        description: "Caipiroska com vodka ou cachaça",
        price: "€5.00",
        category: "drinks"
      },
      {
        id: "vodka",
        name: "Vodka",
        description: "Vodka dose",
        price: "€4.00",
        category: "drinks"
      },
      {
        id: "cachaca",
        name: "Cachaça",
        description: "Cachaça chupito",
        price: "€2.50",
        category: "drinks"
      },
      {
        id: "prosecco",
        name: "Prosecco",
        description: "Prosecco cálice",
        price: "€4.00",
        category: "drinks"
      },
      {
        id: "vino-bianco",
        name: "Vino Bianco",
        description: "Vinho branco cálice",
        price: "€3.00",
        category: "drinks"
      },
      {
        id: "vino-rosso",
        name: "Vino Rosso",
        description: "Vinho tinto cálice",
        price: "€3.00",
        category: "drinks"
      },
      {
        id: "limoncello",
        name: "Limoncello",
        description: "Limoncello dose",
        price: "€3.00",
        category: "drinks"
      }
    ]
  },

  cervejas: {
    title: "Cervejas",
    subtitle: "Cervejas nacionais e internacionais",
    items: [
      {
        id: "heineken-66",
        name: "Heineken 66",
        description: "Heineken garrafa 66cl",
        price: "€3.50",
        category: "cervejas"
      },
      {
        id: "moretti-66",
        name: "Moretti 66",
        description: "Moretti garrafa 66cl",
        price: "€3.00",
        category: "cervejas"
      },
      {
        id: "corona",
        name: "Corona",
        description: "Corona 33cl",
        price: "€5.00",
        category: "cervejas"
      },
      {
        id: "heineken-33",
        name: "Heineken 33",
        description: "Heineken garrafa 33cl",
        price: "€3.00",
        category: "cervejas"
      },
      {
        id: "moretti-33",
        name: "Moretti 33",
        description: "Moretti garrafa 33cl",
        price: "€2.50",
        category: "cervejas"
      },
      {
        id: "becks-33",
        name: "Becks 33",
        description: "Becks garrafa 33cl",
        price: "€3.00",
        category: "cervejas"
      },
    ]
  },

  sobremesas: {
    title: "Sobremesas",
    subtitle: "Doces tradicionais brasileiros",
    items: [
      {
        id: "mousse-maracuja",
        name: "Mousse al Maracujá",
        description: "Mousse de maracujá refrescante",
        price: "€3.50",
        category: "sobremesas",
        unit: "1 unidade"
      },
      {
        id: "mousse-limao",
        name: "Mousse al Limone",
        description: "Mousse de limão refrescante",
        price: "€3.50",
        category: "sobremesas",
        unit: "1 unidade"
      }
    ]
  }
};

// Função para obter dados de um cardápio específico
export const getMenuData = (menuType) => {
  return menuData[menuType] || null;
};

// Função para obter todos os tipos de cardápio
export const getMenuTypes = () => {
  return Object.keys(menuData);
};
